import React from 'react';
import './index.css';
import { useEffect, useState } from 'react';

const AiChatAdvert = () => {

    const [aiChatAdvert, setAiChatAdvert] = useState(false); // 用于存储是否显示广告
    const [mbHide, setMbHide] = useState(false); // 用于存储是否隐藏广告
    const [cssDistance, setCssDistance] = useState({
        bottom: 0,
        right: 0
    }); // 用于存储计算后的CSS距离


    // 监听类名变化 执行函数
    useEffect(() => {
        const callback = (mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const _e = mutation.target;
                    if (Boolean(_e?.className && typeof _e?.className === 'string')) {
                        if (_e.className.includes('helpdesk-channel-btn-hidden')) {
                            setAiChatAdvert(true);
                        }
                        if (_e.className.includes('helpdesk-channel-btn-show')) {
                            setAiChatAdvert(false);
                        }
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
        });
        return () => observer.disconnect();
    }, []);

    // 监听类名helpdesk-channel-start-btn 点击
    useEffect(() => {
        const handleClick = (e) => {
            setAiChatAdvert(true);
        };

        // 封装一个函数：在当前 DOM 中查找并绑定事件
        const bindLauncherEvent = () => {
            // 绑定点击事件
            const launcher = document.querySelector('.helpdesk-channel-start-btn');
            if (launcher && !launcher.dataset.binded) {
                launcher.addEventListener('click', handleClick);
                launcher.dataset.binded = 'true'; // 防止重复绑定
            }
            const modal = document.querySelector('.__iframe-container-helpdesk-channel');
            // 获取离底部和右边的距离
            if (modal) {
                const bottomDistance = window.getComputedStyle(modal).bottom;
                const rightDistance = window.getComputedStyle(modal).right;
                setCssDistance({
                    bottom: parseFloat(bottomDistance),
                    right: parseFloat(rightDistance)
                });

            }
        };

        // 初始化绑定一次
        bindLauncherEvent();

        // 创建 MutationObserver 监听 DOM 更新
        const observer = new MutationObserver(() => {
            bindLauncherEvent();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        // 组件卸载时清理
        return () => {
            observer.disconnect();
            const launcher = document.querySelector('.helpdesk-channel-start-btn');
            if (launcher) {
                launcher.removeEventListener('click', handleClick);
                delete launcher.dataset.binded;
            }
        };
    }, []);

    // 监听屏幕宽度
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 450) {
                setMbHide(true);
            } else {
                setMbHide(false);
            }
        };
        // 初始化执行一次
        handleResize();
        // 监听窗口变化
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div
            className={`ai-chat-advert ${aiChatAdvert && !mbHide ? 'with-transition' : ''}`}
            style={{
                opacity: aiChatAdvert ? 1 : 0,
                display: mbHide || !Boolean(cssDistance?.bottom || cssDistance?.right) ? 'none' : 'flex',
                bottom: `${80}px`,
                right: `${cssDistance?.right}px`
            }}
            onClick={() => {
                window.open("https://share.channelwill.com/NLvqWLyN", "_blank");
            }}
        >
            <p>
                Get Free AI Chatbot
                {/* <span>
                    <img alt="" src="https://cdn.shopify.com/s/files/applications/8efc27b294ac5ead3707607c5c0347de_200x200.png?1758879129" />
                    Chatwill
                </span> */}
            </p>
        </div>
    );
};

export default AiChatAdvert;